import React from 'react';
import {func} from 'prop-types';

import ActionsPanelItem from '../../components/ActionsPanelItem';

import classes from './ActionInsert.module.css';

const AreaActionInsert = ({
    onToggleCreateEquipmentModal
}) => {

    return (
        <div className={classes.agentActions}>
            <ActionsPanelItem
                title="Create a new Equipment"
                iconUrl="/assets/images/equipmentTreeIcon.svg"
                onClick={() => onToggleCreateEquipmentModal(true)}
            />
        </div>
    );
};

AreaActionInsert.defaultProps = {
    onToggleCreateEquipmentModal: () => {}
};

AreaActionInsert.propTypes = {
    onToggleCreateEquipmentModal: func
};

export default AreaActionInsert;
